import React from 'react';
import PropTypes from 'prop-types';
import { intersectionBy, isArray, isEqual, isObject, sortBy } from 'lodash';

import { withStyles } from '@mui/styles';
import Select from '../../Select/Select';
import MenuItem from '../../MenuItem/MenuItem';
import { isEmptyOperator, isMultipleOperator } from './utils';
import Checkbox from '../../Checkbox/Checkbox';

const styles = {
  noPaddingLeft: {
    '& .MuiSelect-select': {
      paddingLeft: 0,
    },
  },
};

const valueExists = ({ options, value }) => {
  let values = [{ name: value }];

  if (isArray(value)) {
    values = value.map((v) => ({ name: v }));
  }

  return intersectionBy(options, values, 'name').length === values.length;
};

class ValueEditorSelect extends React.Component {
  static getDerivedStateFromProps(props, state) {
    const operatorChanged = props.operator !== state.operator;
    const multiple = isMultipleOperator(props.operator);

    const { value } = props;
    let formattedValue = value;

    if (value) {
      if (multiple && !isArray(value)) {
        formattedValue = [value];
      } else if (!multiple && isArray(value)) {
        formattedValue = value[0];
      }

      if (!isEqual(value, formattedValue)) {
        props.onChange(formattedValue);
      }
    }

    if (operatorChanged || !valueExists(props)) {
      const value = multiple ? [] : props.options[0]?.name || null;

      if (value !== null) {
        props.onChange(value);
      }

      return {
        operator: props.operator,
      };
    }

    return null;
  }

  state = {
    operator: this.props.operator,
  };

  onChange = (event) => {
    this.props.onChange(event.target.value);
  };

  selectionRenderer = (values) =>
    sortBy(values)
      .map((val) => {
        const filteredOptions = this.props.options.filter(({ name }) => name === val);

        return filteredOptions.map(({ label, value }) => (isObject(label) ? value : label));
      })
      .join(', ');

  render() {
    const { operator, classes } = this.props;
    let { value } = this.props;

    const multiple = isMultipleOperator(operator);

    if (multiple && !isArray(value)) {
      value = [value];
    } else if (!multiple && isArray(value)) {
      value = value[0];
    }

    return (
      <Select
        value={isEmptyOperator(this.state.operator) ? '' : value}
        style={this.props.style}
        multiple={multiple}
        onChange={this.onChange}
        disabled={this.props.disabled}
        renderValue={multiple ? this.selectionRenderer : null}
        className={classes.noPaddingLeft}
      >
        {this.props.options.map(({ name, label }) => (
          <MenuItem key={name} value={name} title={label}>
            <div style={{ display: 'flex' }}>
              {multiple && <Checkbox checked={value.includes(name)} />}
              {label}
            </div>
          </MenuItem>
        ))}
      </Select>
    );
  }
}

ValueEditorSelect.propTypes = {
  operator: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.any,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(styles)(ValueEditorSelect);
